import { StripePricingPage } from '@/components/subscription'

export function PricingPage() {
  return <StripePricingPage />
}
